export const isALK = (alk: string) => {
  if (typeof alk !== 'string') {
    return false;
  }
  return /^A[0-9]{11}$/.test(alk);
};
